export default __webpack_public_path__ + "static/media/img_search_placeholder.31ed7d20.png";